import { render, staticRenderFns } from "./VehicleProvisionStatisticsTable.vue?vue&type=template&id=d8c327e6&"
import script from "./VehicleProvisionStatisticsTable.vue?vue&type=script&lang=js&"
export * from "./VehicleProvisionStatisticsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QTr,QTh,QTd} from 'quasar'
component.options.components = Object.assign({QTable,QTr,QTh,QTd}, component.options.components || {})
